/* v140: moved out of layout/theme.liquid, where it was printed inline into
   the HTML of every page (about 5KB each). Same code, now cached once by the
   browser and loaded with defer. See the UNIFORM INTERNALS comment in
   layout/theme.liquid for what it does. */
(function () {
  'use strict';
  if (window.__toiLoadMore) { return; }
  window.__toiLoadMore = true;

  var GRIDS = ['#productGrid', '.product-grid', '.blog-grid', '.collections-grid', '.article-grid'];

  function findGrid(root) {
    for (var i = 0; i < GRIDS.length; i++) {
      var el = root.querySelector(GRIDS[i]);
      if (el) { return el; }
    }
    return null;
  }

  /* Cards that arrive after page load still need their wishlist toggle. */
  function bindNew(scope) {
    if (!scope.querySelectorAll) { return; }
    var buttons = scope.querySelectorAll('.wishlist-btn');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (btn.getAttribute('data-toi-wl')) { continue; }
      btn.setAttribute('data-toi-wl', '1');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var on = this.classList.toggle('is-active');
        this.setAttribute('aria-pressed', on);
      });
    }
  }

  function watchGrid(grid) {
    if (!window.MutationObserver) { return; }
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) { bindNew(added[j]); }
        }
      }
    }).observe(grid, { childList: true });
  }

  function nextFrom(root) {
    var pag = root.querySelector('.pagination');
    if (!pag) { return ''; }
    var a = pag.querySelector('.next a') || pag.querySelector('a[rel="next"]');
    return a ? a.getAttribute('href') : '';
  }

  /* A — collection pages: the theme already renders a Load more button.
     Leave it visible and untouched, just keep new cards wired up. */
  function fromButton() {
    var box = document.querySelector('[data-load-more]');
    if (!box) { return false; }
    var btn = box.querySelector('[data-load-more-btn]');
    if (!btn || !box.getAttribute('data-next-url')) { return false; }
    document.documentElement.classList.add('toi-has-loadmore');
    var grid = findGrid(document);
    if (grid) { watchGrid(grid); }
    return true;
  }

  /* B — search, blog and any other paginated list: replace the numbered
     links with the same Load more button. */
  function fromPagination() {
    var pag = document.querySelector('.pagination');
    if (!pag) { return false; }
    var next = nextFrom(document);
    if (!next) { return false; }
    var grid = findGrid(document);
    if (!grid) { return false; }

    document.documentElement.classList.add('toi-has-loadmore');
    watchGrid(grid);

    var box = document.createElement('div');
    box.className = 'load-more toi-loadmore';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'btn btn-primary load-more__btn';
    btn.textContent = 'Load more';
    box.appendChild(btn);
    pag.parentNode.insertBefore(box, pag);

    var busy = false;

    function fail() {
      busy = false;
      document.documentElement.classList.remove('toi-has-loadmore');
      if (box.parentNode) { box.parentNode.removeChild(box); }
    }

    btn.addEventListener('click', function () {
      if (busy || !next) { return; }
      busy = true;
      btn.disabled = true;
      btn.textContent = 'Loading…';

      window.fetch(next, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin'
      }).then(function (r) {
        if (!r.ok) { throw new Error(r.status); }
        return r.text();
      }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = findGrid(doc);
        if (!incoming) { throw new Error('no grid'); }
        var kids = Array.prototype.slice.call(incoming.children);
        var frag = document.createDocumentFragment();
        for (var i = 0; i < kids.length; i++) {
          frag.appendChild(document.importNode(kids[i], true));
        }
        grid.appendChild(frag);
        next = nextFrom(doc);
        busy = false;
        btn.disabled = false;
        btn.textContent = 'Load more';
        if (!next) { box.classList.add('is-done'); }
      }).catch(fail);
    });

    return true;
  }

  function init() {
    if (!fromButton()) { fromPagination(); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
